import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import SearchBoxComponent from "./SearchBoxComponent";

const containerStyle = {
  width: "100%",
  height: "400px",
};

// GoogleMapComponent renders a Google Map with a search box and allows users to select a location.
const GoogleMapComponent = ({ initialCenter, onLocationSelect }) => {
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [center, setCenter] = useState(initialCenter);

  // Update center and selected position when initialCenter changes
  useEffect(() => {
    if (initialCenter) {
      const lat = initialCenter.lat;
      const lng = initialCenter.lng;
      setCenter(initialCenter);
      setSelectedPosition({ lat, lng });
    }
  }, [initialCenter]);

  // Handle map click to update selected position
  const handleMapClick = useCallback(
    (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      setSelectedPosition({ lat, lng });
      onLocationSelect({ lat, lng });
    },
    [onLocationSelect],
  );

  // Handle place selection from the search box
  const handlePlaceSelected = useCallback(
    (location) => {
      setCenter(location);
      setSelectedPosition(location);
      onLocationSelect(location);
    },
    [onLocationSelect],
  );

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyDsRu-MTsNpY5ncbIvG8E58h_qDizh4p6A"
      libraries={["places"]}
    >
      <SearchBoxComponent onPlaceSelected={handlePlaceSelected} />
      <br />
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onClick={handleMapClick}
      >
        {selectedPosition && <Marker position={selectedPosition} />}
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
